import React, { useState, useEffect } from 'react';
import Navbar from '../home/Navbar';
import Footer from '../home/Footer';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const CommingSoon = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <section className="min-h-screen bg-gradient-to-r from-white to-success/40 flex flex-col">
        <Navbar />

        <main className="flex-grow flex flex-col justify-center items-center py-16 px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-3xl md:text-3xl lg:text-4xl font-bold text-center mb-3 text-secondary">
            Thank you for your interest
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-center text-gray-600 mb-10 max-w-xl">
            We're working hard to bring you something amazing. Stay tuned!
          </p>

          <div className="w-60 h-60 sm:w-72 sm:h-72 md:w-96 md:h-96 flex justify-center items-center">
            <DotLottieReact
              src="https://lottie.host/a1af1ab5-3423-4396-9a08-0d81eca4ef10/LkqaUkfKir.lottie"
              loop
              autoplay
              speed={1.5}
              className="w-full h-full"
            />
          </div>
        </main>

        <Footer />
      </section>
    </>
  );
};

export default CommingSoon;
